import 'lazysizes';
import { createRoot } from 'react-dom/client';

import { LandingPage } from '@src/pages/landing/components/landing';
import { ChewyHeader } from '@src/components/global-nav/header';
import { ChewyFooter } from '@src/components/global-nav/footer';
import { GlobalContexts } from '@src/contexts/providers/global-contexts';

const wrapper = document.getElementById('hc-pet-insurance__landing');
const root = createRoot(wrapper);

root.render(
  <GlobalContexts pageContextData={wrapper?.dataset}>
    <ChewyHeader />
    <LandingPage />
    <ChewyFooter />
  </GlobalContexts>,
);
